<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-form ref="form" v-model="valid" :lazy-validation="true" autocomplete="off">
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica dichiarazione di vendita</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete label="Cliente" v-model="customerModel" :search-input.sync="customerSearch"
                  :items="customers" :loading="isLoading" hide-no-data hide-selected item-text="text" item-value="id"
                  return-object :rules="[rules.required]" required></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.serial_number" label="IMEI" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.ean" label="EAN">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.brand" label="Brand" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.model" label="Modello" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.color" label="Colore" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.grade" label="Grado Estetico" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.cost" label="Costo" type="number" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.price" label="Prezzo" type="number" :rules="[rules.required]"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.ram" label="RAM" :rules="[rules.required]" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.disk_space" label="HDD" :rules="[rules.required]" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-textarea v-model="editedItem.description" label="Descrizione"></v-textarea>
              </v-col>
              <v-col cols="12" sm="6">

                <span class="font-weight-bold">Carica DVP firmato</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <v-btn color="blue" elevation="1" outlined small @click="uploadPDF" v-if="filePdfSigned">
                  <v-icon small>
                    mdi-upload
                  </v-icon>
                </v-btn>
                <v-file-input id="pdf-file" small-chips accept="image/*,.pdf" v-model="filePdfSigned" placeholder="Seleziona file" color="blue"></v-file-input>
                <br />
                <!--
                  <span class="font-weight-bold">Scarica DVP firmato</span>&nbsp;&nbsp;
                <v-btn color="green" elevation="1" outlined small @click="pdfSignedDownload">
                  <v-icon small>
                    mdi-download
                  </v-icon>
                </v-btn>
                -->
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">Chiudi</v-btn>
          <v-btn color="primary" text @click="save">Salva e rigenera DVP</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'
import { getDVPPath } from '../../../utils'

export default {
  name: 'EditForm',
  data() {
    return {
      search: null,
      customerSearch: null,
      model: null,
      customerModel: null,
      address: null,
      IDDocs: null,
      customers: [],
      isLoading: false,
      valid: false,
      filePdfSigned: null,
      editedItem: {},
      rules: {
        required: value => !!value || 'Campo obbligatorio.',
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      },
      configPDF: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json',
          'Accept': 'application/pdf'
        },
        responseType: 'arraybuffer',
      },
    }
  },

  props:
  {
    item: { type: Object }
  },

  computed: {
    ...mapGetters([
      'getUsatoClientiEdit'
    ]),
    dialog: {
      get() {
        return this.getUsatoClientiEdit
      },
      set() {
        this.CHANGE_USATO_CLIENTI_EDIT(false)
      }
    },
  },

  methods: {
    ...mapMutations([
      'CHANGE_USATO_CLIENTI_EDIT'
    ]),

    async fetchsecondHand() {

      const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/secondHand/customer/fetch-to-edit`, { id: this.item.id }, this.config)

      this.model = data
      this.editedItem = data

    },

    async fetchCustomers() {

      const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/customers/fetch`, this.config)

      this.customers = data.map(el => {

        el.text = `${el.name} ${el.surename} [${el.phone}]`

        return el
      })
    },

    close() {
      this.CHANGE_USATO_CLIENTI_EDIT(false)
      this.filePdfSigned = null
    },

    async save() {
      if (this.$refs.form.validate()) {
        
        this.$emit('edit-submit', 'reset')

        await axios.post(`${process.env.VUE_APP_API}/pdfDelete`, { payload: this.editedItem }, this.config);

        let customerInfo = { name: this.customerModel.name, surname: this.customerModel.surename }

        this.editedItem.customerInfo = customerInfo;

        this.editedItem.pdf_path = getDVPPath(this.customerModel.name, this.customerModel.surename, this.editedItem.serial_number, this.editedItem.brand, this.editedItem.model, this.editedItem.progressive)
        let dvpInfo = { secondHand: this.editedItem, customer: this.customerModel, address: this.customerModel.addresses[0], IDDocs: this.customerModel.ID_docs }

        await this.pdfCreate(dvpInfo);        

        const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/secondHand/customer/update`, { secondHand: this.editedItem, customer: this.customerModel }, this.config)

        if (data.status) {

          this.$emit('edit-submit', 'ok')
          this.close()
        } else {

          this.$emit('edit-submit', 'error')
        }

      }
    },
    async pdfCreate(payload) {

      try {
        let {
          data
        } = await axios.post(`${process.env.VUE_APP_API}/pdfCreate`, { payload: payload }, this.config)

        if (data) {
          console.log(data);
        } else {
          alert('Si è verificato un errore.')
        }

      } catch (error) {
        console.log(error)
      }
    },
    async uploadPDF() {

      try {
        let formData = new FormData();              

        formData.append("pdf-file", this.filePdfSigned);
        formData.append("name", this.item.name);
        formData.append("surname", this.item.surename);
        formData.append("serial_number", this.item.serial_number);
        formData.append("pdf_path", this.item.pdf_path);

        let {
          data
        } = await axios.post(`${process.env.VUE_APP_API}/pdfUpload`, formData, this.config)

        if (data) {          
          alert("File caricato correttamente")
          this.close()
        } else {
          alert('Si è verificato un errore: file da caricare mancante')
        }

      } catch (error) {
        console.log(error)
      }

    },
    async pdfSignedDownload() {

      try {

        let formData = new FormData();

        formData.append("name", this.item.name);
        formData.append("surname", this.item.surename);
        formData.append("serial_number", this.item.serial_number);
        formData.append("pdf_path", this.item.pdf_path);

        let {
          data
        } = await axios.post(`${process.env.VUE_APP_API}/pdfSignedDownload`, formData, this.configPDF);

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `DVP_Firmata_${this.item.name}_${this.item.surename}_IMEI-${this.item.serial_number}.pdf`);
        document.body.appendChild(link);
        link.click();

      } catch (error) {
        console.log(error)
        alert('Si è verificato un errore: DVP non presente')

      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close() && this.CHANGE_USATO_CLIENTI_EDIT(false)
    },

    async item(val) {

      this.fetchsecondHand()

      this.fetchCustomers()
        .then(() => {
          this.customers.map(el => {
            if (el.name == val.name && el.surename == val.surename) {              
              this.customerModel = el             
            }
          })
        })
    },

    model(val) {
      if (val) {
        this.editedItem = val
      }
    },
  },
}
</script>

<style>
</style>